module.exports = __webpack_public_path__ + "img/Dinapsis_fondo.ee28c485.svg";